// Blog Navigation JavaScript
// Handles search functionality and navigation for the blog nav bar

(function() {
  'use strict';

  // Wait for DOM to be ready
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  // Blog search functionality
  function initBlogSearch() {
    const searchContainer = document.querySelector('.blog-header__search-container');
    console.log('Blog Navigation JS: Looking for search container:', searchContainer);
    
    if (!searchContainer) {
      console.log('Blog Navigation JS: Search container not found');
      return;
    }



    // Search form submission handler
    const searchForm = searchContainer.querySelector('#blogSearchForm');
    if (searchForm) {
      searchForm.addEventListener('submit', function(event) {
        const searchInput = this.querySelector('.blog-site-header__search-input');
        const searchTerm = searchInput?.value?.trim();
        
        if (!searchTerm) {
          event.preventDefault();
          return;
        }
        
        // The form will submit normally to the search results page
        // The type="article" parameter ensures it searches for blog posts
        console.log('Blog Navigation JS: Submitting search for:', searchTerm);
      });
    }

    // Clear button handler
    const clearButton = searchContainer.querySelector('#blogSearchClear');
    if (clearButton) {
      clearButton.addEventListener('click', function(event) {
        const searchInput = searchContainer.querySelector('.blog-site-header__search-input');
        if (searchInput) {
          searchInput.value = '';
          searchInput.focus();
          console.log('Blog Navigation JS: Search cleared');
        }
      });
    }

    // Search input focus handler for better UX
    const searchInput = searchContainer.querySelector('.blog-site-header__search-input');
    if (searchInput) {
      searchInput.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
          this.value = '';
          this.blur();
          console.log('Blog Navigation JS: Search cleared with Escape key');
        }
      });
    }



    console.log('Blog Navigation JS: Search functionality initialized');
  }

  // Blog filter functionality
  function initBlogFilters() {
    const filterButtons = document.querySelectorAll('.blog-filter-btn');
    const blogPosts = document.querySelectorAll('.blog-post-card, .blog-post-list__highlighted-article');
    
    if (!filterButtons.length) {
      return;
    }

    filterButtons.forEach(button => {
      button.addEventListener('click', function() {
        const filterValue = this.getAttribute('data-filter');
        
        // Update active button
        filterButtons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
                
        let postCount = 0

        // Filter blog posts
        blogPosts.forEach(post => {
          if (filterValue === 'all') {
            post.style.display = 'block';
            post.style.opacity = '1';
            postCount++
          } else {
            // Check if post has the matching tag
            const postTags = post.querySelectorAll('.meta-information span');
            let hasMatchingTag = false;
            
            postTags.forEach(tag => {
              const tagText = tag.textContent.toLowerCase();
              if (tagText.includes(filterValue.replace('-', ' '))) {
                hasMatchingTag = true;
              }
            });
            
            if (hasMatchingTag) {
              postCount++
              post.style.display = 'block';
              post.style.opacity = '1';
            } else {
              post.style.display = 'none';
              post.style.opacity = '0';
            }
          }
        });

        console.log(postCount)
        
        console.log('Blog Navigation JS: Filtered by:', filterValue);
      });
    });

    console.log('Blog Navigation JS: Blog filters initialized');
  }

  // Load more functionality
  function initLoadMore() {
    const loadMoreBtn = document.querySelector('.load-more-btn');
    
    if (!loadMoreBtn) {
      return;
    }

    loadMoreBtn.addEventListener('click', function(event) {
      const currentPage = parseInt(event.target.getAttribute('data-current-page'));
      const totalPages = parseInt(event.target.getAttribute('data-total-pages'));
      const nextPageUrl = event.target.getAttribute('data-next-page-url');
      
      if (currentPage >= totalPages) {
        event.target.style.display = 'none';
        return;
      }

      // Show loading state
      event.target.classList.add('loading');
      event.target.textContent = 'Loading...';
      event.target.disabled = true;

      // Fetch next page
      fetch(nextPageUrl)
        .then(response => response.text())
        .then(html => {
          // Create a temporary div to parse the HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          
          // Find the blog post list in the new content
          const newBlogList = tempDiv.querySelector('.blog-post-list');
          const currentBlogList = document.querySelector('.blog-post-list');
          
          if (newBlogList && currentBlogList) {
            // Extract new blog posts
            const newPosts = newBlogList.querySelectorAll('.blog-post-card');
            
            // Append new posts to current list
            newPosts.forEach(post => {
              currentBlogList.appendChild(post.cloneNode(true));
            });

            
            
            // Update button data
            const newLoadMoreBtn = tempDiv.querySelector('.load-more-btn');
            if (newLoadMoreBtn) {
              event.target.setAttribute('data-current-page', newLoadMoreBtn.getAttribute('data-current-page'));
              event.target.setAttribute('data-next-page-url', newLoadMoreBtn.getAttribute('data-next-page-url'));
            } else {
              // No more pages, hide button
              event.target.style.display = 'none';
            }
          }
        })
        .catch(error => {
          console.error('Error loading more posts:', error);
          event.target.textContent = 'Error loading posts. Please try again.';
        })
        .finally(() => {
          // Reset button state
          event.target.classList.remove('loading');
          event.target.textContent = 'Load More Articles';
          event.target.disabled = false;
          
          // Reinitialize filters for new posts
          initBlogFilters();
        });
    });

    console.log('Blog Navigation JS: Load more functionality initialized');
  }

  // Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    console.log('Blog Navigation JS: DOM ready, initializing...');
    initBlogSearch();
    initBlogFilters();
    initLoadMore();
  });

  // Re-initialize if content is dynamically loaded (for Shopify sections)
  if (typeof window !== 'undefined') {
    window.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('.blog-header__search-container')) {
        initBlogSearch();
      }
      if (event.target.querySelector('.blog-filter-section')) {
        initBlogFilters();
      }
      if (event.target.querySelector('.load-more-btn')) {
        initLoadMore();
      }
    });
  }

})(); 